module.exports = __webpack_public_path__ + "img/teen.67be788c.jpg";